import { metriwsBaseUrl } from "../api/baseUrl";
import {
    GET_CUSTOMER_DETAILS,
    PARSE_CHARGEBACK,
    BLOCK_CHARGEBACK_CUSTOMER,
} from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getCustomerDetails = (payload) => {
    return apiInstance.post(GET_CUSTOMER_DETAILS, payload);
};

export const parseChargeback = (payload) => {
    return apiInstance.post(PARSE_CHARGEBACK, payload, {
        baseURL: metriwsBaseUrl,
    });
};

export const blockChargebackCustomer = (payload) => {
    return apiInstance.post(BLOCK_CHARGEBACK_CUSTOMER, payload);
};


